import React from 'react';

import { Amenity } from '@/molecules/property-card';

const MapMarkerContent: React.FC<{
  property: any;
}> = ({ property }) => {
  return (
    <div className="flex min-w-[150px] min-h-[100px] flex-col items-center justify-around">
      <div className="text-xl">{property.name}</div>
      <div className="text-xl">
        <span dangerouslySetInnerHTML={{ __html: property.location.currency?.symbol || '$' }} />
        <span>{property.baseRate}</span>
      </div>
      <div className="items-center text-center" title={property.address}>
        <span className="text-sm text-gray-500">{property.address || '-'}</span>
      </div>
      <div className="flex flex-row max-w-[150px] overflow-hidden">
        {property.baseAttributes.map((attribute) => (
          <Amenity key={attribute.key} value={attribute.value} icon={attribute.icon} />
        ))}
      </div>
    </div>
  );
};

export default MapMarkerContent;
